var $55b0693b2cf3fe91$exports = {};
$55b0693b2cf3fe91$exports = {
  "breadcrumbs": "\u0422\u0440\u043E\u0445\u0438 \u0445\u043B\u044F\u0431"
};
export { $55b0693b2cf3fe91$exports as default };